import { jsx as s } from "react/jsx-runtime";
import { $ as n } from "../../vendor-EQDp64ng.js";
function v({ children: e, id: i, ...r }) {
  const { visuallyHiddenProps: o } = n(), t = {
    assertive: "alert",
    polite: "status"
  }, a = r["aria-live"] ?? "polite";
  return /* @__PURE__ */ s(
    "span",
    {
      id: i,
      role: t[a],
      "aria-live": a,
      ...o,
      "data-component": "AriaLive",
      children: e
    }
  );
}
export {
  v as AriaLive
};
